import script from "./StatusDocument.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusDocument.vue?vue&type=script&setup=true&lang=js"

import "./StatusDocument.vue?vue&type=style&index=0&id=d50fb9d4&lang=css"

const __exports__ = script;

export default __exports__